(() => {
  const sectionSelector = '[data-section-type="tangible-header-v5"]';

  const applyVideoLogo = (section) => {
    if (!section || section.dataset.tgh5VideoLogoReady === 'true') return;

    const sectionId = section.dataset.sectionId;
    const template = document.getElementById(`Tgh5VideoLogoTemplate-${sectionId}`);
    const logo = section.querySelector('.tgh5-logo');

    if (!template || !logo) return;

    logo.replaceChildren(template.content.cloneNode(true));
    logo.classList.remove('tgh5-logo--video-fallback');
    logo.classList.add('tgh5-logo--video');
    section.dataset.tgh5VideoLogoReady = 'true';

    const video = logo.querySelector('[data-tgh5-logo-video]');
    if (!video) return;

    video.muted = true;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
      return;
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const initialise = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) {
      applyVideoLogo(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(sectionSelector).forEach(applyVideoLogo);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
